import classNames from "classnames";
import React, {HTMLAttributes} from "react";
import {twMerge} from "tailwind-merge";

export const Error: React.FC<HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
}) => {
  return (
    <div
      className={twMerge(
        classNames("pt-1 text-red-400 text-sm flex-1", {
          invisible: !children,
        }),
        className,
      )}
    >
      {children || "clean"}
    </div>
  );
};
